export const insoleInspectionUIHTML = `
<style>
    #background
    {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding: 10px;
        pointer-events: initial;
        background-color: #f4f5f6;
        box-sizing: border-box;
    }

    .onoffswitch-label-container
    {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        user-select: none;
        height: 34px;
        font-family: Trebuchet, Arial, sans-serif;
    }

    .onoffswitch-text
    {
        font-size: 20px;
        font-weight: bold;
        vertical-align: middle;
        margin: 0 10px;
    }

    .onoffswitch
    {
        position: relative;
        width: 90px;
        height: 34px;
    }

    .onoffswitch-checkbox
    {
        display: none;
    }

    .onoffswitch-label
    {
        display: block;
        overflow: hidden;
        cursor: pointer;
        width: 100%;
        height: 100%;
        border: 2px solid #EAEAEA;
        border-radius: 100vh;
        box-sizing: border-box;
    }

    .onoffswitch-label-disabled
    {
        color: #999999;
    }

    .onoffswitch-inner
    {
        display: block;
        width: 200%;
        margin-left: -100%;
        transition: margin 0.25s ease-in-out;
    }

    .onoffswitch-inner:before,
    .onoffswitch-inner:after
    {
        display: block;
        float: left;
        width: 50%;
        height: 30px;
        padding: 0;
        line-height: 30px;
        font-size: 14px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
    }

    .onoffswitch-inner:before
    {
        content: "ON";
        padding-left: 10px;
        background-color: #231e21;
        color: #FFFFFF;
    }

    .onoffswitch-inner:after
    {
        content: "OFF";
        padding-right: 10px;
        background-color: #f4f5f6;
        color: #999999;
        text-align: right;
    }

    .onoffswitch-switch
    {
        display: block;
        width: 18px;
        margin: 8px;
        background: #FFFFFF;
        position: absolute;
        top: -2px;
        right: 54px;
        border: 2px solid #EAEAEA;
        border-radius: 20px;
        transition: all 0.25s ease-in-out;
        height: 18px;
    }

    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner
    {
        margin-left: 0px;
    }

    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch
    {
        right: -2px;
    }

    .onoffswitch-checkbox:disabled + .onoffswitch-label .onoffswitch-inner:before,
    .onoffswitch-checkbox:disabled + .onoffswitch-label .onoffswitch-inner:after
    {
        background-color: #c7c7c7;
    }

    .onoffswitch label
    {
        margin: 0px;
    }
</style>

<div id="background">
    <label>
        <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 282 145.7'%3E%3Cpath d='M61 9h41v.4L80 38.2h1.4c13 0 22.8 7.8 22.8 19.7 0 12.7-11 21-22.7 21C69.3 79 60.2 71.3 59 59h7.2c1 8.2 6.7 13.4 15.2 13.4 9 0 15.2-6 15.2-14.3 0-8.4-6.2-14-16.6-14H67.4v-.5l21.2-28H61zm83.5 0L127 40c3-3.8 8-6 13.8-6 12 0 21.7 9.4 21.7 22.2 0 12.3-9.7 22.7-23.8 22.7C125 79 115 69 115 56a29 29 0 0 1 3.5-13.6l18-33.3zm-6 63.5c10.2 0 16.3-7.5 16.3-16 0-8.8-5.6-16-15.7-16a16 16 0 0 0-16.7 16.2c0 9.4 6.6 16 16 16zM173 54V32.6a23 23 0 0 1 24.2-25 23 23 0 0 1 24.2 25V54c0 14.6-9.2 25-24.2 25S173 68.5 173 54zm41-22c0-10-5.7-17.8-16.6-17.8s-16.6 8-16.6 17.8v22.3c0 10 5.7 17.8 16.6 17.8S214 64 214 54.3z'/%3E%3Cpath d='M141 125C64 125 1.5 109 1.5 89.5c0-9.8 15.6-18.7 41-25M234 63c28.5 6.5 46.5 16 46.5 26.5 0 8.5-11.8 16.4-31.6 22.5l-36.5 8q-4.8.7-9.8 1.4' fill='none' stroke='%23000' stroke-miterlimit='10' stroke-width='3'/%3E%3Cpath d='M140.5 103.5V143l34-19.8-34-19.8z' stroke='%23000' stroke-miterlimit='10' stroke-width='3'/%3E%3Ccircle cx='234' cy='9.5' r='8' fill='none' stroke='%23000' stroke-width='3'/%3E%3C/svg%3E"
            height="48px" draggable="false">
        <input type="checkbox" id="rotate-checkbox" style="display: none;">
    </label>

    <label class="onoffswitch-label-container" id="left-container">
        <div class="onoffswitch-text">Left foot</div>
        <div class="onoffswitch">
            <input type="checkbox" name="show-left" class="onoffswitch-checkbox" id="show-left">
            <label class="onoffswitch-label" for="show-left">
                <span class="onoffswitch-inner"></span>
                <span class="onoffswitch-switch"></span>
            </label>
        </div>
    </label>

    <label class="onoffswitch-label-container" id="right-container">
        <div class="onoffswitch-text">Right foot</div>
        <div class="onoffswitch">
            <input type="checkbox" name="show-right" class="onoffswitch-checkbox" id="show-right">
            <label class="onoffswitch-label" for="show-right">
                <span class="onoffswitch-inner"></span>
                <span class="onoffswitch-switch"></span>
            </label>
        </div>
    </label>
</div>
`;
//# sourceMappingURL=insole-inspection-ui.js.map